import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Flex,
  Image,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react";

import TextLoop from "react-text-loop";

type IntroProps = {
  title: string;
  subtitle: string;
  image: string;
  formLink: string;
  formText: string;
};

const Intro = ({ title, subtitle, image, formLink, formText }: IntroProps) => {
  return (
    <Flex
      align="center"
      justify={{ base: "center", md: "space-around", xl: "space-between" }}
      direction={{ base: "column-reverse", md: "row" }}
      wrap="nowrap"
      minH="70vh"
      px={8}
      mb={16}
    >
      <Stack
        spacing={4}
        w={{ base: "80%", md: "40%" }}
        align={["center", "center", "flex-start", "flex-start"]}
      >
        <Heading
          as="h1"
          size="xl"
          fontWeight="bold"
          color="primary.800"
          textAlign={["center", "center", "left", "left"]}
        >
          Let's make the recruitment process{" "}
          <TextLoop springConfig={{ stiffness: 20, damping: 8 }}>
            <span>quick</span>
            <span>easy</span>
            <span>smooth</span>
          </TextLoop>
        </Heading>
        <Heading
          as="h2"
          size="md"
          color="primary.800"
          opacity="0.8"
          fontWeight="normal"
          lineHeight={1.5}
          textAlign={["center", "center", "left", "left"]}
        >
          {subtitle}
        </Heading>
        <Link to={formLink}>
          <Button
            colorScheme="teal"
            borderRadius="8px"
            py="4"
            px="4"
            lineHeight="1"
            size="md"
          >
            {formText}
          </Button>
        </Link>
        <Text
          fontSize="xs"
          mt={2}
          textAlign="center"
          color="primary.800"
          opacity="0.6"
        ></Text>
      </Stack>
      <Box w={{ base: "80%", sm: "60%", md: "50%" }} mb={{ base: 12, md: 0 }}>
        {/* TODO: Make this change every X secs */}
        <Image src={image} size="100%" rounded="1rem" shadow="2xl" />
      </Box>
    </Flex>
  );
};

Intro.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  formText: PropTypes.string,
  formLink: PropTypes.string,
};

Intro.defaultProps = {
  title: "Let's make these easy for both of us",
  subtitle:
    "Please enter the specifics of the job. If this job aligns with my goals I will simply reach out to you to take the next steps.",
  image: "https://unsplash.com/photos/FWoq_ldWlNQ",
  formText: "Recruit me",
  formLink: "/recruitme",
};

export default Intro;
